import React from 'react';
import { ThemedText } from '../../../components';

export default function TextValue({ formatted, emptyValue = '—', theme }) {
  if (formatted == null) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }
  return <ThemedText>{formatted}</ThemedText>;
}
